import { gql } from '@apollo/client';

export default gql`
  fragment MediaListItem on MediaItem {
    _id
    name
    processed
    enabled
    subject
    thumbUrl
    type
    availableFrom
    availableUpTo
    isExternal
    externalUrl
  }
`;
